import { ConfirmExit } from './ConfirmExit';
import { GameContent } from './GameContent';
import { Options } from './Options';
import { MainMenu } from './mainMenu';

export {
  Wrapper,
  SimpleWindow,
  SimpleButton,
  CanvasApi,
  ACTIONS,
  TYPES,
  HSLA,
  GameInput,
  ActionFrame,
  Display,
  DisplayBottomWidget,
  DisplayWidget,
  WidgetText,
  FigureGenerator,
  Grid,
  Game,
  Timer
} from '../index';

export default {
  ConfirmExit,
  GameContent,
  MainMenu,
  Options
};



// WEBPACK FOOTER //
// ./src/components/interface/stages/index.js